import React, {useEffect, useState} from "react";
import ValueInputField from "../Elements/ValueInputField";
import InputTypeHidden from "../Elements/InputTypeHidden";
import PlzInputField from "../Elements/PlzInputField";


const StromPrivat = (props) => {
    const [htValue, setHtValue] = useState(3000);
    const [ntValue, setNtValue] = useState(3000);
    const [plz, setPlz] = useState();

    return <div className="heizstrom">
        <p><strong>Finden Sie hier Ihr passendes Heizstrom-Produkt:</strong></p>
        <div className="row row-small-gutters">
            <div className="col-sm-12">
                <PlzInputField setDisableButton={props.setDisableButton} setErrorText={props.setErrorText} type="POWER" setShowError={props.setShowError} name="postalCode" placeholder="Ihre PLZ"/>
            </div>
        </div>

        <p>Jahresverbrauch in kWh/Jahr</p>
        <div className="row row-small-gutters">
            <div className="col-sm-6">
                <ValueInputField name="consumption" setValue={setHtValue} placeholder="HT (kWh)" value={htValue}/>
            </div>
            <div className="col-sm-6">
                <ValueInputField name="consumptionNT" setValue={setNtValue} placeholder="NT (kWh)" value={ntValue}/>
            </div>
            <InputTypeHidden name="customerType" value="PRIVATE"/>
            <InputTypeHidden name="mediaType" value="POWER"/>
        </div>
    </div>
}

export default StromPrivat;